import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import "leaflet/dist/leaflet.css";

// Fix Leaflet marker issue for React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

const MapPage = ({ devices }) => {
  const [filter, setFilter] = useState("All");
  const [search, setSearch] = useState("");

  // ✅ Filter + Search
  const filteredSensors = devices.filter((sensor) => {
    const matchStatus = filter === "All" || sensor.status === filter;
    const matchSearch = sensor.name.toLowerCase().includes(search.toLowerCase());
    return matchStatus && matchSearch;
  });

  // ✅ Export CSV
  const exportCSV = () => {
    const csv = Papa.unparse(filteredSensors);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "devices.csv");
  };

  // ✅ Dynamic Marker Color
  const getMarkerIcon = (status) =>
    new L.Icon({
      iconUrl:
        status === "Online"
          ? "https://maps.google.com/mapfiles/ms/icons/green-dot.png" // Green marker icon
          : "https://maps.google.com/mapfiles/ms/icons/red-dot.png", // Red marker icon
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
    });

  return (
    <div className="p-6 bg-gray-900 text-white min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Sensor Map</h1>

      {/* ✅ Filters */}
      <div className="flex flex-wrap items-center gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded w-48"
        />
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded"
        >
          <option value="All">All</option>
          <option value="Online">Online</option>
          <option value="Offline">Offline</option>
        </select>
        <button
          onClick={exportCSV}
          className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white ml-auto"
        >
          Export CSV
        </button>
      </div>

      {/* ✅ Full Screen Map */}
      <MapContainer
        center={[20.5937, 78.9629]} // India center
        zoom={5}
        style={{ height: "80vh", width: "100%", borderRadius: "12px" }}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
        />

        {filteredSensors.map((sensor) => (
          <Marker
            key={sensor.id}
            position={[sensor.lat, sensor.lng]}
            icon={getMarkerIcon(sensor.status)}
          >
            <Popup>
              <div>
                <h4 className="font-bold">{sensor.name}</h4>
                <p>Status: {sensor.status}</p>
                <p>Last Updated: {sensor.lastUpdated}</p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default MapPage;
